export default {
  getLevelInfo(grade, level) {
    let info = [
      { info: ['本次考核成绩为100分（满分）', '本次考核成绩在标准区间之上(84-99分)', '本次考核成绩在标准区间之内(76-83分)', '本次考核成绩在标准区间之下(20-75分)', '本次考核成绩低于20分，需要继续努力'] },
      { info: ['本次考核成绩为100分（满分）', '本次考核成绩在标准区间之上(86-99分)', '本次考核成绩在标准区间之内(77-85分)', '本次考核成绩在标准区间之下(20-76分)', '本次考核成绩低于20分，需要继续努力'] },
      { info: ['本次考核成绩为100分（满分）', '本次考核成绩在标准区间之上(90-99分)', '本次考核成绩在标准区间之内(82-89分)', '本次考核成绩在标准区间之下(20-81分)', '本次考核成绩低于20分，需要继续努力'] },
      { info: ['本次考核成绩为100分（满分）', '本次考核成绩在标准区间之上(89-99分)', '本次考核成绩在标准区间之内(81-88分)', '本次考核成绩在标准区间之下(20-80分)', '本次考核成绩低于20分，需要继续努力'] },
      { info: ['本次考核成绩为100分（满分）', '本次考核成绩在标准区间之上(86-99分)', '本次考核成绩在标准区间之内(76-85分)', '本次考核成绩在标准区间之下(20-75分)', '本次考核成绩低于20分，需要继续努力'] },
      { info: ['本次考核成绩为100分（满分）', '本次考核成绩在标准区间之上(82-99分)', '本次考核成绩在标准区间之内(71-81分)', '本次考核成绩在标准区间之下(20-70分)', '本次考核成绩低于20分，需要继续努力'] },
      { info: ['本次考核成绩为100分（满分）', '本次考核成绩在标准区间之上(74-99分)', '本次考核成绩在标准区间之内(63-73分)', '本次考核成绩在标准区间之下(20-62分)', '本次考核成绩低于20分，需要继续努力'] },
      { info: ['本次考核成绩为100分（满分）', '本次考核成绩在标准区间之上(78-99分)', '本次考核成绩在标准区间之内(68-78分)', '本次考核成绩在标准区间之下(20-67分)', '本次考核成绩低于20分，需要继续努力'] },
    ]
    let index;
    switch (level) {
      case 'A+':
        index = 0;
        break;
      case 'A':
        index = 1;
        break;
      case 'B':
        index = 2;
        break;
      case 'C':
        index = 3;
        break;
      case 'Try Harder':
        index = 4;
        break;
    }
    return info[grade - 1].info[index]
  }
}


// WEBPACK FOOTER //
// ./src/config/levelInfo.js